import { setStorage, getStorage, caculateAKSN, httpBuildQuery } from './core';
import geolocation from './geolocation';
import { request } from './request';
import { MAP_AK } from './conf';

/**
 * @file 封装 获取用户定位接口,包括经纬度
 * @author guoyong03
 */

/* globals getApp, Page  */

// get方法 在h5下面 无法获得 province 需要自己处理
export function get(refresh = false, autoSave = true) {
  const locData = getStorage('location');
  if (!refresh && locData && locData !== '') {
    autoSave && set(locData);
    return Promise.resolve(locData);
  } else {
    return new Promise((resolve, reject) => {
      geolocation.getPosition({
        onSuccess(pos) {
          let locData = {
            lat: pos.lat,
            long: pos.long,
            cityCode: pos.cityCode,
            cityName: (pos.addr && pos.addr.city || '').replace('市', ''),
            curCity: (pos.addr && pos.addr.city || '').replace('市', '')
          };
          autoSave && set(locData);
          return resolve(locData);
        },
        onFail(err) {
          console.log('geolocation fail', err); // eslint-disable-line
          return reject('geolocation fail');
        }
      });
    });
  }
}
export function set(loc) {
  let location = {
    // 纬度
    lat: null,
    // 经度
    long: null,
    // 城市和经纬度不一定匹配，城市用户可选择，经纬度始终是当前位置经纬度
    cityCode: null,
    cityName: null,
    curCity: null,
    // 经纬度所在城市
    province: null // 省份，经销商中台接口需要省份
  };

  let currLoc = getApp().globalData.location;
  location = Object.assign(location, currLoc, loc);

  // 更新全局变量
  getApp().globalData.location = Object.assign(getApp().globalData.location, location);

  // 更新本地缓存
  setStorage('location', location);
}

// 根据地址获取经纬度
export function getTargetLoaction(address) {
  return new Promise((resolve, reject) => {
    geolocation.getLocation({
      timeout: 8000,
      address,
      onSuccess(res) {
        return resolve(res);
      },
      onFail() {
        return reject('getTargetLoaction fail');
      }
    });
  });
}

// 根据经纬度获取地址
export function getTargetAddress(lat, lng) {
  return new Promise((resolve, reject) => {
    geolocation.getAddress({
      timeout: 8000,
      lat,
      lng,
      onSuccess(res) {
        return resolve(res);
      },
      onFail() {
        return reject('getTargetAddress fail');
      }
    });
  });
}
export default {
  set,
  get,
  getTargetLoaction,
  getTargetAddress
}; // eslint-disable-line